// Province name normalization between the DB (UPPERCASE, free-text) and the
// bundled Indonesia-provinces TopoJSON feature names.
//
// TOPO_NAME_PROP and the right-hand values below MUST match the output of
// scripts/inspect-topo.js for the bundled asset.
//
// Source: https://raw.githubusercontent.com/denyherianto/indonesia-geojson-topojson-maps-with-38-provinces/main/TopoJSON/indonesia-38-provinces.topo.json
// TopoJSON object key: indonesia-38-prov-topo
// Feature property keys: KODE_PROV, PROVINSI
// Total features: 38 (covers 34 DB provinces; 4 new Papua sub-provinces are uncovered)

export const TOPO_NAME_PROP = 'PROVINSI';

export const ALL_DB_PROVINCES: string[] = [
  'BALI',
  'BANGKA BELITUNG',
  'BANTEN',
  'BENGKULU',
  'DI YOGYAKARTA',
  'DKI JAKARTA',
  'GORONTALO',
  'JAMBI',
  'JAWA BARAT',
  'JAWA TENGAH',
  'JAWA TIMUR',
  'KALIMANTAN BARAT',
  'KALIMANTAN SELATAN',
  'KALIMANTAN TENGAH',
  'KALIMANTAN TIMUR',
  'KALIMANTAN UTARA',
  'KEPULAUAN RIAU',
  'LAMPUNG',
  'MALUKU',
  'MALUKU UTARA',
  'NANGGROE ACEH DARUSSALAM (NAD)',
  'NUSA TENGGARA BARAT (NTB)',
  'NUSA TENGGARA TIMUR (NTT)',
  'PAPUA',
  'PAPUA BARAT',
  'RIAU',
  'SULAWESI BARAT',
  'SULAWESI SELATAN',
  'SULAWESI TENGAH',
  'SULAWESI TENGGARA',
  'SULAWESI UTARA',
  'SUMATERA BARAT',
  'SUMATERA SELATAN',
  'SUMATERA UTARA',
];

// DB provinsi (UPPERCASE) -> exact TopoJSON PROVINSI feature name.
// Anomaly reconciliations:
//   BANGKA BELITUNG       -> Kepulauan Bangka Belitung  (asset uses full official name)
//   NANGGROE ACEH DARUSSALAM (NAD) -> Aceh              (asset uses shortened official name)
//   DI YOGYAKARTA         -> Daerah Istimewa Yogyakarta (asset uses full official name)
//   DKI JAKARTA           -> DKI Jakarta                (case difference only)
//   NUSA TENGGARA BARAT (NTB)  -> Nusa Tenggara Barat  (parenthetical stripped)
//   NUSA TENGGARA TIMUR (NTT)  -> Nusa Tenggara Timur  (parenthetical stripped)
//   KEPULAUAN RIAU        -> Kepulauan Riau             (case difference only)
//   PAPUA and PAPUA BARAT map to asset's Papua and Papua Barat respectively.
//   4 new Papua sub-provinces in asset (Papua Barat Daya, Papua Pegunungan,
//   Papua Selatan, Papua Tengah) have no DB counterpart and are intentionally uncovered.
export const dbToTopo: Record<string, string> = {
  'BALI': 'Bali',
  'BANGKA BELITUNG': 'Kepulauan Bangka Belitung',
  'BANTEN': 'Banten',
  'BENGKULU': 'Bengkulu',
  'DI YOGYAKARTA': 'Daerah Istimewa Yogyakarta',
  'DKI JAKARTA': 'DKI Jakarta',
  'GORONTALO': 'Gorontalo',
  'JAMBI': 'Jambi',
  'JAWA BARAT': 'Jawa Barat',
  'JAWA TENGAH': 'Jawa Tengah',
  'JAWA TIMUR': 'Jawa Timur',
  'KALIMANTAN BARAT': 'Kalimantan Barat',
  'KALIMANTAN SELATAN': 'Kalimantan Selatan',
  'KALIMANTAN TENGAH': 'Kalimantan Tengah',
  'KALIMANTAN TIMUR': 'Kalimantan Timur',
  'KALIMANTAN UTARA': 'Kalimantan Utara',
  'KEPULAUAN RIAU': 'Kepulauan Riau',
  'LAMPUNG': 'Lampung',
  'MALUKU': 'Maluku',
  'MALUKU UTARA': 'Maluku Utara',
  'NANGGROE ACEH DARUSSALAM (NAD)': 'Aceh',
  'NUSA TENGGARA BARAT (NTB)': 'Nusa Tenggara Barat',
  'NUSA TENGGARA TIMUR (NTT)': 'Nusa Tenggara Timur',
  'PAPUA': 'Papua',
  'PAPUA BARAT': 'Papua Barat',
  'RIAU': 'Riau',
  'SULAWESI BARAT': 'Sulawesi Barat',
  'SULAWESI SELATAN': 'Sulawesi Selatan',
  'SULAWESI TENGAH': 'Sulawesi Tengah',
  'SULAWESI TENGGARA': 'Sulawesi Tenggara',
  'SULAWESI UTARA': 'Sulawesi Utara',
  'SUMATERA BARAT': 'Sumatera Barat',
  'SUMATERA SELATAN': 'Sumatera Selatan',
  'SUMATERA UTARA': 'Sumatera Utara',
};

export const topoToDb: Record<string, string> = Object.fromEntries(
  Object.entries(dbToTopo).map(([db, topo]) => [topo, db])
);
